import styled from 'styled-components';

export const ChargesControl = styled.div<{justify?: string}>`
    width: 100%;
    justify-content: ${(p) => p.justify ?? 'flex-start'};
    display: inline-flex;
    align-items: center;
    gap: 8px;
`;

export const ControlContainer = styled.div`
    margin-left: auto;
    display: flex;
    gap: 8px;
`;
